import { useState } from 'react';

function IconExpand({ className, width = 24, height = 24, id, color, hoverColor, isExpanded, onClick }: any) {
	const [mainColor, setMainColor] = useState(color);
	const expandPath =
		'M15 5h4a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V8.41l-4.3 4.3a1 1 0 0 1-1.4-1.42L16.58 7H15a1 1 0 1 1 0-2zM9 19H5a1 1 0 0 1-1-1v-4a1 1 0 1 1 2 0v1.59l4.3-4.3a1 1 0 0 1 1.4 1.42L7.42 17H9a1 1 0 1 1 0 2z';
	const restorePath =
		'M14 11a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0v1.59L19.3 3.3a1 1 0 1 1 1.4 1.42L16.42 9H18a1 1 0 1 1 0 2h-4zM10 13a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-1.59L4.7 20.7a1 1 0 0 1-1.4-1.42L7.58 15H6a1 1 0 1 1 0-2h4z';
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			onMouseEnter={() => setMainColor(hoverColor)}
			onMouseLeave={() => setMainColor(color)}
			onClick={() => onClick()}
		>
			<g fill="none" fillRule="evenodd">
				<path d="M0 0h24v24H0z" />
				<path id={id} fill={mainColor} d={isExpanded ? restorePath : expandPath} />
			</g>
		</svg>
	);
}

export default IconExpand;
